@if (connection.issue(); as issue) {
  <div class="banner" animate.enter="banner-enter" animate.leave="banner-leave">
    @switch (issue) {
      @case ('offline') {
        <svg class="banner-icon banner-icon-down" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M1 1L23 23M16.72 11.06A10.94 10.94 0 0 1 19 12.55M5 12.55A10.94 10.94 0 0 1 10.17 10.16M10.71 5.05A16 16 0 0 1 22.58 9M1.42 9A15.91 15.91 0 0 1 6.12 6.12M8.53 16.11A6 6 0 0 1 15.48 16.11M12 20H12.01"/>
        </svg>
        <span class="banner-text" role="alert">{{ 'global.connection.offline' | translate }}</span>
      }
      @case ('unreachable') {
        <svg class="banner-icon banner-icon-down" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M22.61 16.95A5 5 0 0 0 18 10H16.74A8 8 0 0 0 9.69 4M5 5A8 8 0 0 0 9 20H18A5 5 0 0 0 19.7 19.7M1 1L23 23"/>
        </svg>
        <span class="banner-text" role="alert">{{ 'global.connection.unreachable' | translate }}</span>
        <span class="banner-retry-in" aria-hidden="true">{{ retryStatusKey() | translate: {seconds: secondsLeft()} }}</span>
        <app-icon-text-button size="compact" icon="assets/icons/refresh-cw-01.svg" [loading]="connection.probing()" (click)="connection.retryNow()">
          {{ 'global.loadError.retry' | translate }}
        </app-icon-text-button>
      }
      @case ('restored') {
        <svg class="banner-icon banner-icon-restored" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"/>
        </svg>
        <span class="banner-text" role="status">{{ 'global.connection.restored' | translate }}</span>
        <app-countdown-close-button [duration]="restoredDuration" (closed)="connection.dismissRestored()" />
      }
    }
  </div>
}
